//总后台路由管理
var homeRouter = [{
	path: '/',
	name: 'home',
	component: () => import('@/page/home'),
	//  meta  来控制是否使用公共的headerfooter
	meta: {
		title: '首页',
		layout: 'defaultLayout',
		activeMenu:'/',
	}
},{
	path: '/recruitment',
	name: 'recruitment',
	component: () => import('@/page/recruitment'),
	//  meta  来控制是否使用公共的headerfooter
	meta: {
		title: '招聘公告',
		layout: 'defaultLayout',
		activeMenu:'/recruitment',
	}
},{
	path: '/recruitment/info',
	name: 'recruitmentInfo',
	component: () => import('@/page/recruitment/info'),
	//  meta  来控制是否使用公共的headerfooter
	meta: {
		title: '招聘公告详情',
		layout: 'defaultLayout',
		activeMenu:'/recruitment',
	}
},{
	path: '/study',
	name: 'study',
	component: () => import('@/page/study'),
	//  meta  来控制是否使用公共的headerfooter
	meta: {
		title: '学习中心',
		layout: 'defaultLayout',
		activeMenu:'/study',
	}
},{
	path: '/study/info',
	name: 'studyInfo',
	component: () => import('@/page/study/info'),
	//  meta  来控制是否使用公共的headerfooter
	meta: {
		title: '学习中心详情',
		layout: 'defaultLayout',
		activeMenu:'/study',
	}
}]
export default homeRouter
